import { DEFAULT_HEADERS, LOGOUT_URL, PUBLIC_KEYS_URL, TOKEN_EXCHANGE_URL, TOKEN_REFRESH_URL, VALIDATE_TOKEN_URL, GET_PROFILE_URL, MAGIC_LINK_LOGIN, SEND_MAGIC_LINK_EMAIL, TOKEN_EXCHANGE_ONE_TIME_USE_URL, FORGOT_PASSWORD, RESET_PASSWORD, } from './constants/index.js';
import { getBearerHeaders } from './utils/index.js';
export const microAuthApi = {
    getProfile: async (token) => {
        const bearer_headers = getBearerHeaders(token);
        try {
            const response = await fetch(`${GET_PROFILE_URL}`, {
                method: 'GET',
                headers: bearer_headers,
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
    getPublicKeys: async () => {
        try {
            const response = await fetch(`${PUBLIC_KEYS_URL}`, {
                method: 'GET',
                headers: DEFAULT_HEADERS,
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
    logout: async (token) => {
        const body = {
            access_token: token,
        };
        try {
            const response = await fetch(`${LOGOUT_URL}`, {
                method: 'POST',
                headers: DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
    magicLinkLogin: async (token) => {
        const body = {
            token,
        };
        try {
            const response = await fetch(`${MAGIC_LINK_LOGIN}`, {
                method: 'POST',
                headers: DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
    resetPassword: async (token, password) => {
        const body = {
            token,
            password,
        };
        try {
            const response = await fetch(`${RESET_PASSWORD}`, {
                method: 'POST',
                headers: DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
    sendForgotPasswordEmail: async (email) => {
        const body = {
            email,
        };
        try {
            const response = await fetch(`${FORGOT_PASSWORD}`, {
                method: 'POST',
                headers: DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
    sendMagicLinkEmail: async (email) => {
        const body = {
            email,
        };
        try {
            const response = await fetch(`${SEND_MAGIC_LINK_EMAIL}`, {
                method: 'POST',
                headers: DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
    tokenExchange: async (idToken) => {
        const body = {
            token: idToken,
        };
        try {
            const response = await fetch(`${TOKEN_EXCHANGE_URL}`, {
                method: 'POST',
                headers: DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
    tokenExchangeForOneTimeUseToken: async (idToken) => {
        const body = {
            token: idToken,
        };
        try {
            const response = await fetch(`${TOKEN_EXCHANGE_ONE_TIME_USE_URL}`, {
                method: 'POST',
                headers: DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
    tokenRefresh: async (token) => {
        const body = {
            token: token,
        };
        try {
            const response = await fetch(`${TOKEN_REFRESH_URL}`, {
                method: 'POST',
                headers: DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
    validateToken: async (token) => {
        const body = {
            access_token: token,
        };
        try {
            const response = await fetch(`${VALIDATE_TOKEN_URL}`, {
                method: 'POST',
                headers: DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });
            const isSuccess = response.status >= 200 && response.status < 400;
            if (isSuccess) {
                return {
                    data: await response.json(),
                    isError: false,
                    isSuccess: true,
                    status: response.status,
                };
            }
            else {
                return {
                    error: await response.text(),
                    isError: true,
                    isSuccess: false,
                    status: response.status,
                };
            }
        }
        catch (error) {
            return {
                isError: true,
                isSuccess: false,
                error,
                exceptionThrown: true,
                status: 500,
            };
        }
    },
};
//# sourceMappingURL=micro-auth-api.js.map